import PropTypes from "prop-types";

/**
 * Shared citation content component
 * Renders the citation text, PubMed button, and navigation
 */
const CitationContent = ({
  citationNumber,
  displayText,
  fallbackUrl,
  hasPubMed,
  onPubMedClick,
  onUrlClick,
  onViewAllReferences,
  styles,
  classNames = {},
  viewAllButtonText = "View all references",
  hidePubMedWhenEmpty = false,
  showCitationNumber = false,
}) => {
  return (
    <>
      <div className={classNames.content || styles.citationContent}>
        {showCitationNumber && citationNumber && (
          <sup className={classNames.superscript || styles.citationSuperscript}>
            {citationNumber}
          </sup>
        )}
        {displayText}
        {fallbackUrl && (
          <>
            <br />
            <span className={classNames.urlLink || styles.citationUrlLink} onClick={onUrlClick}>
              {fallbackUrl}
            </span>
          </>
        )}
      </div>

      {!(hidePubMedWhenEmpty && !hasPubMed) && (
        <div className={classNames.actions || styles.citationActions}>
          <button
            className={`${classNames.pubmedButton || styles.pubmedButton} ${hasPubMed ? classNames.active || styles.active : classNames.disabled || styles.disabled}`}
            disabled={!hasPubMed}
            onClick={onPubMedClick}
            title="PubMed"
          >
            {classNames.pubmedText ? (
              <span className={classNames.pubmedText}>PubMed</span>
            ) : (
              "PubMed"
            )}
          </button>
          {hasPubMed && classNames.externalIcon && (
            <i
              className={`tg-icons-Open ${classNames.externalIcon}`}
              onClick={onPubMedClick}
              title="Open in new tab"
            ></i>
          )}
        </div>
      )}

      {viewAllButtonText && (
        <div className={classNames.navigation || styles.citationNavigation}>
          <button
            className={classNames.viewAllButton || styles.viewAllButton}
            onClick={onViewAllReferences}
          >
            <span className={classNames.viewAllText || styles.viewAllText}>
              {viewAllButtonText}
            </span>
            {classNames.viewAllArrow && (
              <i className={`tg-icons-LeftArrow ${classNames.viewAllArrow}`}></i>
            )}
          </button>
        </div>
      )}
    </>
  );
};

CitationContent.propTypes = {
  citationNumber: PropTypes.number,
  displayText: PropTypes.string.isRequired,
  fallbackUrl: PropTypes.string,
  hasPubMed: PropTypes.bool.isRequired,
  onPubMedClick: PropTypes.func.isRequired,
  onUrlClick: PropTypes.func.isRequired,
  onViewAllReferences: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired,
  classNames: PropTypes.shape({
    content: PropTypes.string,
    superscript: PropTypes.string,
    urlLink: PropTypes.string,
    actions: PropTypes.string,
    pubmedButton: PropTypes.string,
    active: PropTypes.string,
    disabled: PropTypes.string,
    externalIcon: PropTypes.string,
    navigation: PropTypes.string,
    viewAllButton: PropTypes.string,
    viewAllText: PropTypes.string,
    viewAllArrow: PropTypes.string,
  }),
  viewAllButtonText: PropTypes.string,
  hidePubMedWhenEmpty: PropTypes.bool,
  showCitationNumber: PropTypes.bool,
};

export default CitationContent;
